
export class UserAppAccessLogDTO {
    loggingId: string;
    applicationName: string;
    tokenId: string;
    sessionId: string;
    userName: string;

    winUserId: string;
    domain: string;
    loginTime: string;
    logoutTime: string;
    tokenActiveFlag: string;

    loggegInFlag: string;
    url: string;
    userId: string;
    browser: string;
    landingPage: string;

    UUID: string;
    ip_address: string;

}